import { render, staticRenderFns } from "./WillGifts.vue?vue&type=template&id=b060bdc6"
import script from "./WillGifts.vue?vue&type=script&lang=js"
export * from "./WillGifts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports